<template>
	<div>
		<div v-for="item of receiptOptions" :key="item.id" class="weui-cells" @click="handleOption(item.id)">
			<div class="weui-cell weui-cell_active weui-cell_access">
				<div class="weui-cell__bd">
					<span style="vertical-align: middle;">{{item.name}}</span>
				</div>
				<div class="weui-cell__ft"></div>
			</div>
		</div>
	</div>
</template>

<script>
    import { mapMutations } from 'vuex'
    export default {
        name: "index",
		data () {
            return {
                receiptOptions: [
					{name: '停车费开票',id:1},
                    {name: '车位费开票',id:2},
                    // {name: '优惠券开票',id:3},
                    {name: '开票历史',id:4},
				]
			}
		},
		methods: {
            ...mapMutations({
                setReceiptOrderSnObj: "SET_RECEIPT_ORDERSN_OBJ",
            }),
            handleOption (id) {
                if (id === 1){
					this.$router.push('userParkingFeeList');
                    this.$vnode.parent.componentInstance.cache = {};
                    this.$vnode.parent.componentInstance.keys = [];
                    this.setReceiptOrderSnObj({})
				} else if (id === 2){
					this.$router.push({name:'parkingFee',query:{isReceipt: true}});
                    this.setReceiptOrderSnObj({})
				} else if (id === 3) {
                    this.$router.push('couponOrder');
                    this.$vnode.parent.componentInstance.cache = {};
                    this.$vnode.parent.componentInstance.keys = [];
                    this.setReceiptOrderSnObj({})
				} else {
                    this.$router.push('receiptHistory')
				}
			}
		}
    }
</script>

<style scoped lang="stylus">

	.weui-cells{
		margin-top 0
		.weui-cell_access{
			display flex
			justify-content space-between
		}
	}
	.weui-cell_access .weui-cell__cash{
		padding-right 0
	}
	.weui-cell_access .weui-cell__cash:after{
		width 0
		height 0
		border-width 0
	}
	.weui-cell__ft::after{
		content:" ";
		display:inline-block;
		height:8px;
		width:8px;
		border-width:2px 2px 0 0;
		border-color:#B2B2B2;
		border-style:solid;
		-webkit-transform:matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		transform:matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		position:absolute;
		top:50%;
		margin-top:-5px;
		right:0;
	}
</style>
